import React, { FC, useState } from "react";
import { InputSelect, InputText } from "../../../../components/input";

import { IInputArrayFormProps, IInputArrayDataStructureItem } from "../../../../components/input/arrayData";
import { CreateNotification } from "../../../../components/notifier";
import { getDDMMYYYFormat } from "../../../../helper/dateTimeHelper";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { ObjectUtils } from "../../../../modules/utils";
import { UploadFile } from "../../uploadFile";
import { InputDateRangePicker } from "../../../../components/input/date-range-picker";
import { Upload } from "../../upload";
import { InputGroupSelect } from "../../../../components/input/select/select-group";
import { getDefaultEstimatedTimeOfUse, getDefaultTeam } from "../../util";

// structure ngắn hạn cấp mới
export const ShortTermNewBusinessVehicleCardFormStructure: IInputArrayDataStructureItem[] = [
  {
    name: "unit",
    label: "Đội/Tổ",
    isVisibleOnList: true,
  },
  {
    name: "nameVehical",
    label: "Tên phương tiện",
    isVisibleOnList: true,
  },
  {
    name: "licensePlate",
    label: "Biển kiểm soát",
    isVisibleOnList: true,
  },
  {
    name: "vehicleRegistrationCertificate",
    label: "Giấy đăng ký phương tiện/Giấy phép khai thác thiết bị hàng không",
    isVisibleOnList: true,
  },
  {
    name: "vehicleRegistrationCertificateId",
    label: "Số giấy đăng ký phương tiện/Giấy phép khai thác thiết bị hàng không",
    isVisibleOnList: true,
  },
  {
    name: "certificateOfInspection",
    label:
      "Sổ chứng nhận kiểm định ATKT và BVMT giao thông/Biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
    isVisibleOnList: true,
  },
  {
    name: "certificateOfInspectionId",
    label:
      "Số chứng nhận kiểm định ATKT và BVMT giao thông/Biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
    isVisibleOnList: true,
  },
  {
    name: "driveLicense",
    label: "Giấy phép lái xe",
    isVisibleOnList: true,
  },
  {
    name: "grantPeriod",
    label: "Thời hạn cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantedArea",
    label: "Khu vực đề nghị",
    isVisibleOnList: true,
  },
  {
    name: "gateAway",
    label: "Cổng vào",
    isVisibleOnList: true,
  },
  {
    name: "exit",
    label: "Cổng ra",
    isVisibleOnList: true,
  },
];
// structure ngắn hạn cấp lại
export const ShortTermRenewBusinessVehicleCardFormStructure: IInputArrayDataStructureItem[] = [
  {
    name: "unit",
    label: "Đội/Tổ",
    isVisibleOnList: true,
  },
  {
    name: "nameVehical",
    label: "Tên phương tiện",
    isVisibleOnList: true,
  },
  {
    name: "licensePlate",
    label: "Biển kiểm soát",
    isVisibleOnList: true,
  },
  {
    name: "vehicleRegistrationCertificate",
    label: "Giấy đăng ký phương tiện/Giấy phép khai thác thiết bị hàng không",
    isVisibleOnList: true,
  },
  {
    name: "vehicleRegistrationCertificateId",
    label: "Số giấy đăng ký phương tiện/Giấy phép khai thác thiết bị hàng không",
    isVisibleOnList: true,
  },
  {
    name: "certificateOfInspection",
    label:
      "Sổ chứng nhận kiểm định ATKT và BVMT giao thông/Biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
    isVisibleOnList: true,
  },
  {
    name: "certificateOfInspectionId",
    label:
      "Số chứng nhận kiểm định ATKT và BVMT giao thông/Biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
    isVisibleOnList: true,
  },

  {
    name: "driveLicense",
    label: "Giấy phép lái xe",
    isVisibleOnList: true,
  },
  {
    name: "grantPeriod",
    label: "Thời hạn cấp",
    isVisibleOnList: true,
  },
  {
    name: "grantedArea",
    label: "Khu vực đề nghị",
    isVisibleOnList: true,
  },
  {
    name: "gateAway",
    label: "Cổng vào",
    isVisibleOnList: true,
  },
  {
    name: "exit",
    label: "Cổng ra",
    isVisibleOnList: true,
  },
  {
    name: "OldKSANCardPhoto",
    label: "Bản photo giấy phép phương tiện đã cấp",
    isVisibleOnList: true,
  },
  {
    name: "ExcuseLose",
    label: "Đơn cớ mất",
    isVisibleOnList: true,
  },
];
// Form ngắn hạn cấp mới
export const ShortTermNewBusinessVehicleCardContentForm: FC<IInputArrayFormProps> = (props: any) => {
  const { childFormData } = props;
  console.log("🚀 ~ file: shortTermBusinessVehicleCard.tsx:177 ~ childFormData:", childFormData);
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(
    getDefaultEstimatedTimeOfUse(childFormData?.grantPeriod),
  );
  const [selectedTeam, setSelectedTeam] = useState(
    getDefaultTeam(childFormData?.unit, props.teamList.length > 0 ? props.teamList[0] : null, props.teamList),
  );

  const today = new Date();

  const onTeamChange = (selectedOptions: any) => {
    setSelectedTeam(selectedOptions ? selectedOptions : null);
  };

  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item: any) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      values.unit = selectedTeam ? selectedTeam.value : values.unit;
      values.grantPeriod = estimatedTimeOfUse
        ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1])
        : values.grantPeriod;
      // values.vehicleRegistrationCertificate =
      //   values.vehicleRegistrationCertificate.length > 0 ? JSON.stringify(values.vehicleRegistrationCertificate) : "";
      // values.certificateOfInspection =
      //   values.certificateOfInspection.length > 0 ? JSON.stringify(values.certificateOfInspection) : "";
      // values.grantedArea = values.grantedArea.length > 0 && JSON.stringify(values.grantedArea);

      if (
        !values.nameVehical ||
        // !values.vehicleRegistrationCertificate ||
        !values.vehicleRegistrationCertificateId ||
        !values.unit ||
        !values.gateAway ||
        !values.grantedArea ||
        !values.grantPeriod ||
        // !values.certificateOfInspection ||
        !values.certificateOfInspectionId ||
        !values.licensePlate ||
        !values.exit
      ) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      } else props.onSubmit(values);
    },
  });

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc{" "}
      </h6>

      <InputWraper
        inputProps={getInputProps("unit")}
        renderInput={(s) => (
          <InputSelect
            {...s}
            options={props.teamList.map((o: any) => ({
              id: o.id,
              label: o.value,
              value: o.value,
            }))}
            value={selectedTeam?.value}
            onChange={onTeamChange}
            placeholder="* Chọn đội/tổ"
          />
        )}
        isRequired
      />

      <InputWraper inputProps={getInputProps("nameVehical")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper inputProps={getInputProps("licensePlate")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("vehicleRegistrationCertificate")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />

      <InputWraper
        inputProps={getInputProps("vehicleRegistrationCertificateId")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("certificateOfInspection")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />

      <InputWraper
        inputProps={getInputProps("certificateOfInspectionId")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper inputProps={getInputProps("driveLicense")} renderInput={(s) => <UploadFile {...s} />} />

      <InputWraper
        inputProps={getInputProps("grantedArea")}
        renderInput={(s) => <InputGroupSelect {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantPeriod")}
        renderInput={(s) => (
          <InputDateRangePicker {...s} value={estimatedTimeOfUse} onChange={setEstimatedTimeOfUse} minDate={today} />
        )}
        isRequired
      />

      <InputWraper inputProps={getInputProps("gateAway")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("exit")}
        className="py-4"
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
// Form ngắn hạn cấp lại
export const ShortTermRenewBusinessVehicleCardContentForm: FC<IInputArrayFormProps> = (props: any) => {
  const { childFormData } = props;
  const today = new Date();
  const [estimatedTimeOfUse, setEstimatedTimeOfUse] = useState(
    getDefaultEstimatedTimeOfUse(childFormData?.grantPeriod),
  );
  const [selectedTeam, setSelectedTeam] = useState(
    getDefaultTeam(childFormData?.unit, props.teamList.length > 0 ? props.teamList[0] : null, props.teamList),
  );

  const onTeamChange = (selectedOptions: any) => {
    setSelectedTeam(selectedOptions ? selectedOptions : null);
  };

  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item: any) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      values.unit = selectedTeam ? selectedTeam.value : values.unit;
      values.grantPeriod = estimatedTimeOfUse
        ? getDDMMYYYFormat(estimatedTimeOfUse[0]) + "-" + getDDMMYYYFormat(estimatedTimeOfUse[1])
        : values.grantPeriod;
      // values.vehicleRegistrationCertificate =
      //   values.vehicleRegistrationCertificate.length > 0 ? JSON.stringify(values.vehicleRegistrationCertificate) : "";
      // values.certificateOfInspection =
      //   values.certificateOfInspection.length > 0 ? JSON.stringify(values.certificateOfInspection) : "";
      values.ExcuseLose = values.ExcuseLose.length > 0 ? JSON.stringify(values.ExcuseLose) : "";
      // values.grantedArea = values.grantedArea.length > 0 && JSON.stringify(values.grantedArea);

      if (
        !values.nameVehical ||
        !values.vehicleRegistrationCertificate ||
        !values.vehicleRegistrationCertificateId ||
        !values.licensePlate ||
        // !values.certificateOfInspection ||
        !values.ExcuseLose ||
        // !values.certificateOfInspectionId ||
        !values.unit ||
        !values.exit ||
        !values.gateAway ||
        !values.grantedArea ||
        !values.grantPeriod
      ) {
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
        return;
      } else props.onSubmit(values);
    },
  });

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc{" "}
      </h6>
      <InputWraper
        inputProps={getInputProps("unit")}
        renderInput={(s) => (
          <InputSelect
            {...s}
            options={props.teamList.map((o: any) => ({
              id: o.id,
              label: o.value,
              value: o.value,
            }))}
            value={selectedTeam?.value}
            onChange={onTeamChange}
            placeholder="* Chọn đội/tổ"
          />
        )}
        isRequired
      />

      <InputWraper inputProps={getInputProps("nameVehical")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper inputProps={getInputProps("licensePlate")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("vehicleRegistrationCertificate")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />

      <InputWraper
        inputProps={getInputProps("vehicleRegistrationCertificateId")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("certificateOfInspection")}
        renderInput={(s) => <UploadFile {...s} />}
        // isRequired
      />

      <InputWraper
        inputProps={getInputProps("certificateOfInspectionId")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper inputProps={getInputProps("driveLicense")} renderInput={(s) => <UploadFile {...s} />} />

      <InputWraper
        inputProps={getInputProps("grantedArea")}
        renderInput={(s) => <InputGroupSelect {...s} />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("grantPeriod")}
        renderInput={(s) => (
          <InputDateRangePicker {...s} value={estimatedTimeOfUse} onChange={setEstimatedTimeOfUse} minDate={today} />
        )}
        isRequired
      />

      <InputWraper inputProps={getInputProps("gateAway")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper inputProps={getInputProps("exit")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper inputProps={getInputProps("OldKSANCardPhoto")} renderInput={(s) => <UploadFile {...s} />} />
      <InputWraper inputProps={getInputProps("ExcuseLose")} renderInput={(s) => <Upload {...s} />} isRequired />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
